export type MaintenanceConfig = {
  maintenanceMessage: string | null;
  affectedRoutes: string[];
  globalMaintenance: boolean;
};

export async function fetchMaintenanceConfig(): Promise<MaintenanceConfig | null> {
  const res = await fetch("/api/v1/maintenance");
  if (!res.ok) return null;

  const payload = await res.json().catch(() => null);
  return payload?.data || null;
}
